import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slider,
  Typography,
} from '@mui/material';
import { getSessionEvents, getSessionReplayExport } from '../../meeting/v2Api';
import { SessionEvent } from '../../meeting/types';

interface SessionReplayProps {
  open: boolean;
  onClose: () => void;
  seriesId: string;
  sessionId: string;
}

export const SessionReplay: React.FC<SessionReplayProps> = ({
  open,
  onClose,
  seriesId,
  sessionId,
}) => {
  const [events, setEvents] = useState<SessionEvent[]>([]);
  const [seq, setSeq] = useState(0);

  useEffect(() => {
    if (!open || !sessionId) return;
    getSessionEvents(seriesId, sessionId)
      .then(setEvents)
      .catch((err) => console.warn('Failed to load events', err));
  }, [open, seriesId, sessionId]);

  const maxSeq = events.length > 0 ? events[events.length - 1].seq : 0;

  const exportJson = async () => {
    try {
      const data = await getSessionReplayExport(seriesId, sessionId);
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `smlrer-replay-${sessionId}.json`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.warn('Export failed', err);
    }
  };

  const current = events.find((e) => e.seq === seq);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Session replay (debug)</DialogTitle>
      <DialogContent>
        <Typography variant="body2" gutterBottom>
          Scrub command timeline for this session. Export includes reconstructed snapshots.
        </Typography>
        <Slider
          value={seq}
          min={0}
          max={maxSeq || 0}
          step={1}
          onChange={(_, v) => setSeq(v as number)}
          disabled={maxSeq === 0}
        />
        {current ? (
          <Typography variant="caption" component="pre" sx={{ whiteSpace: 'pre-wrap' }}>
            {JSON.stringify(current.command, null, 2)}
          </Typography>
        ) : (
          <Typography variant="body2">No events recorded for this session yet.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={exportJson}>Export JSON</Button>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
